import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import { sync } from 'vuex-router-sync'
import Cookie from 'js-cookie'
import VueClipboard from 'vue-clipboard2'
import Authorisation from './plugins/authorisations'
import authorisations from './authorisations'
import App from './App'
import store from './store'
import router from './router'
import i18n from './i18n'

// const APP_ID = 'irnlbv1t' // For testing
const APP_ID = 'jmiko15j'
Vue.config.productionTip = false

const currentPlatform = () => store.getters['skiliko/session/currentPlatform']
const currentUser = () => store.getters['skiliko/session/currentUser']
const loggedIn = () => store.getters['skiliko/session/connected']
const needInformations = () => store.getters['skiliko/session/needInformations']

Vue.use(Vuetify)
Vue.use(Authorisation, {
  authorisations,
  currentUser: store => ({
    platform: currentPlatform(),
    user: currentUser()
  })
})
Vue.use(VueClipboard)

sync(store, router)

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth === true) && !loggedIn()) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }
  if (to.matched.some(record => record.meta.auth === false) && loggedIn()) {
    return next({ path: '/' })
  }
  if (needInformations() && to.name !== 'Setup') {
    return next({ name: 'Setup' })
  }
  next()
})

const intercomUser = () => {
  const user = store.getters['skiliko/session/currentUser']
  return user && typeof user === 'object' ? {
    user_id: user.id,
    email: user.email,
    name: [user.first_name, user.last_name].filter(x => x).join(' '),
    phone: user.phone
  } : {}
}

window.intercomSettings = {
  app_id: APP_ID,
  custom_launcher_selector: '#intercom-trigger',
  hide_default_launcher: true,
  ...intercomUser()
}
// https://developers.intercom.com/installing-intercom/docs/basic-javascript
;(function () { var w = window; var ic = w.Intercom; if (typeof ic === 'function') { ic('reattach_activator'); ic('update', w.intercomSettings) } else { var d = document; var i = function () { i.c(arguments) }; i.q = []; i.c = function (args) { i.q.push(args) }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + APP_ID; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x) }; if (document.readyState === 'complete') { l() } else if (w.attachEvent) { w.attachEvent('onload', l) } else { w.addEventListener('load', l, false) } } })()

window.Intercom('boot', {
  app_id: APP_ID,
  ...intercomUser()
})

window.Intercom('hide')

router.afterEach(route => {
  window.Intercom('update', {
    app_id: APP_ID,
    ...intercomUser()
  })
  if (route.name === 'Logout') {
    window.Intercom('shutdown')
  }
})

store.commit('application/UPDATE_PLATFORM_NAME')

const init = () => new Vue({
  el: '#app',
  router,
  store,
  i18n: i18n(currentPlatform() ? currentPlatform().locale : 'fr'),
  render: h => h(App)
})

if (Cookie.getJSON('authorization')) {
  Promise.all([
    store.dispatch('skiliko/session/currentUser', {}, { root: true }),
    store.dispatch('skiliko/session/currentPlatform', { token: Cookie.getJSON('authorization') }, { root: true })
  ])
    .then(init)
} else {
  init()
}



// WEBPACK FOOTER //
// ./src/main.js